import { render, staticRenderFns } from "./CacheDelete.vue?vue&type=template&id=567e23bf"
import script from "./CacheDelete.vue?vue&type=script&lang=js"
export * from "./CacheDelete.vue?vue&type=script&lang=js"
import style0 from "./CacheDelete.vue?vue&type=style&index=0&id=567e23bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports